// @flow

import { stringify } from 'querystring';
import type { GlobalState } from '../types';
import { getAssortmentStore } from './assortment';
import { defaultSortOption } from '../config';

export const getSort = (state: GlobalState) => getAssortmentStore(state).sort;

export const getSortProperty = (state: GlobalState) => getSort(state).property;

export const getSortDirection = (state: GlobalState) => getSort(state).direction;

export const getSortType = (state: GlobalState) => getSort(state).type;

export const getSortKey = (state: GlobalState) => `${getSortProperty(state) || ''}:${getSortDirection(state)}`;

export const isSorting = (state: GlobalState) => getSortKey(state) !== defaultSortOption;

export const getUrlEncodedSort = (state: GlobalState) => {
  if (isSorting(state)) {
    return stringify(({ sort: JSON.stringify(getSort(state)) }));
  }
  return null;
};

export default null;
